import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

const MealPlanViewer = () => {
  const { uniqueIdentifier } = useParams();
  const [error, setError] = useState('');

  const mealPlanUrl = useMemo(() => {
    if (!uniqueIdentifier) {
      return '';
    }
    return `https://api.caloriensweat.com/meal-plan/${uniqueIdentifier}`;
  }, [uniqueIdentifier]);

  useEffect(() => {
    if (!uniqueIdentifier) {
      setError('Invalid meal plan link');
      return;
    }

    window.location.replace(mealPlanUrl);
  }, [mealPlanUrl, uniqueIdentifier]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '32px 24px',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🍽️</div>
        <h1 style={{ fontSize: '24px', color: '#333', marginBottom: '12px' }}>
          Opening Meal Plan
        </h1>
        <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.5', marginBottom: '20px' }}>
          Your meal plan is opening now.
        </p>
        {error ? (
          <p style={{ color: '#dc3545', marginBottom: '20px' }}>{error}</p>
        ) : null}
        {mealPlanUrl ? (
          <a
            href={mealPlanUrl}
            style={{
              display: 'inline-block',
              backgroundColor: '#007bff',
              color: 'white',
              padding: '12px 20px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Open Meal Plan
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default MealPlanViewer;
